import { createContext } from 'react';
import constants from './constants.json';

export const ModalContext = createContext({
  showModal: false,
  handleShowModal: () => {},
  handleCloseModal: () => {},
  groupsArray: [],
  gitlabProjectsUrl: '',
  gitlabUrlAutomation: '',
  PAT: '',
  environments: constants.environments
});

